var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFrameIcon = function SvgFrameIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    fill: "none",
    viewBox: "0 0 28 25"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 13.8,
    x: 3.6,
    y: 4.6,
    stroke: "#b9c3ca",
    strokeWidth: 2,
    rx: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#b9c3ca",
    strokeLinejoin: "round",
    d: "m16.124 8.513.007-.007c.003-.003.007-.006.017-.006.01 0 .032.003.06.027l1.279 1.239c.009.01.013.02.013.033 0 .012-.003.033-.025.059l-.65.65-1.357-1.332.656-.663ZM10.5 15.5v-1.383l3.67-3.687 1.364 1.372-3.663 3.698H10.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#b9c3ca",
    strokeWidth: 2,
    d: "M14 18v3M11.576 21.1h4.85c.531 0 1.036.204 1.404.559.368.354.57.83.57 1.32 0 .052-.01.104-.032.154a.419.419 0 0 1-.095.136.496.496 0 0 1-.334.131h-7.878c-.13 0-.25-.05-.334-.131l-.416.432.416-.432a.402.402 0 0 1-.127-.29c0-.49.202-.966.57-1.32a2.028 2.028 0 0 1 1.406-.559Z"
  })));
};
export default SvgFrameIcon;